<template>
  <div class="warningText">
    <i class="fal fa-info-circle warningIcon" />

    <br />

    <h1>Uwaga</h1>

    <br />

    <h3>{{ schema.text.$model }}</h3>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

// @vuese
// Formularz potwierdzania
export default {
  components,
  props: {
    // schema
    schema: { type: Object, required: true }
  }
};
</script>

<style>
.warningIcon {
  font-size: 7em;
}

.warningText {
  text-align: center;
}
</style>